function addClickListeners() {
  var buttons = document.querySelectorAll('.ds-atc-button:not([data-listener-added])');
  
  buttons.forEach(function(button) {
    button.addEventListener('click', handleClick);
    button.setAttribute('data-listener-added', 'true');
  });
}

function handleClick(event) {
  event.preventDefault();
  var variantId = this.getAttribute('data-variant-id');
  
  if (typeof CartJS !== 'undefined') {
    CartJS.addItem(variantId, 1);
  }
}

// Initial load
document.addEventListener('DOMContentLoaded', addClickListeners);

// For dynamically loaded content
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.addedNodes.length) {
      addClickListeners();
    }
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});